<template>
  <div id="services">
    <div class="container">

      <div class="page-title">
        <div class="name">{{ name }}</div>
        <button class="save btn btn-primary" @click="save">{{ $t('save') }}</button>
      </div>

      <Tabs>
        <TabSection :title="$t('services.title')">
          <div class="group">
            <label>
              <span>{{ $t("services.availability") }}</span>
              <Tooltip :text="$t('services.availability_tooltip')" />
            </label>
          </div>
          <div class="columns" v-if="activated">
            <div class="column">
              <div class="service">
                <span class="service-name">{{ $t("services.online_ordering") }}</span>
                <select v-model="activated.onlineOrdering">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="service">
                <span class="service-name">{{ $t("services.kiosk") }}</span>
                <select v-model="activated.kiosk">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
            </div>
            <div class="column">
              <div class="service">
                <span class="service-name">{{ $t("services.menuboard") }}</span>
                <select v-model="activated.menuBoard">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
            </div>
          </div>
        </TabSection>
      </Tabs>

      <div class="footer-actions">
        <button class="btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: "companyServices",

    data() {
      return {
        id: -1,
        name: null,
        activated: {
          onlineOrdering: true,
          kiosk: false,
          menuBoard: false
        },
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "services.title";
      this.$store.state.pageIcon = "/icon/services.svg";
      if (this.$route.query.company) {
        this.id = this.$route.query.company;
        showSpinner();
        await this.loadCompany();
        hideSpinner();
      }
    },

    methods: {
      ...mapActions(["getCompany", "saveCompany"]),

      async loadCompany() {
        let response = await this.getCompany({
          branchId: this.$route.query.branch,
          companyId: this.id,
          fallback: true
        });
        if (response) {
          this.name = response.name;
          this.activated = {
            onlineOrdering: response.onlineOrdering.activated,
            kiosk: response.kiosk.activated,
            menuBoard: response.menuBoard.activated,
          };
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      },

      async save() {
        this.$store.commit("showSpinner", true);
        let data = {
          activated: this.activated
        };
        await this.saveCompany({ branchId: this.$route.query.branch, companyId: this.id, data });
        this.$store.commit("showSpinner", false);
        toast(this.$t("company.success"), "success");
      },
    }
  }
</script>

<style lang="scss" scoped>
  .service {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    select {
      width: 150px;
    }
  }

  .service-name {
    flex-grow: 1;
    font-weight: 500;
  }
</style>
